import { updateUser } from "../../api/services/userService.js";
import { mapMutations } from "vuex";
export default {
  methods: {
    ...mapMutations(["setStoreLoaded"]),
    submitForm() {
      var that = this;
      let cms = [];
      let detail = this.$refs.myDetail.validate();
      let address = this.$refs.deliveryAddress.validate();
      let addressValidate = this.$refs.deliveryAddress.validateAddress();

      cms.push(detail);
      cms.push(address);
      cms.push(addressValidate);
      Promise.all(cms).then(values => {
        if (values.every(v => v)) {
          that.saveProfile();
        } else {
          that.$el.querySelector("[aria-invalid=true]").focus();
        }
      });
    },
    saveProfile() {
      this.loading = true;
      updateUser(this.user.id, {
        FirstName: this.detailModel.FirstName,
        LastName: this.detailModel.LastName,
        DisplayName:
          this.detailModel.FirstName + " " + this.detailModel.LastName,
        FirebaseUDID: this.user.id,
        Mobile: this.deliveryAddressModel.Phone,
        Email: this.user.email,
        DeliveryAddress: {
          Address: this.deliveryAddressModel.StreetAddress,
          PostCode: this.deliveryAddressModel.PostalCode,
          City: this.deliveryAddressModel.CityTown,
          Phone: this.deliveryAddressModel.Phone,
          State: this.deliveryAddressModel.State,
          Latitude: this.deliveryAddressModel.Latitude
            ? this.deliveryAddressModel.Latitude
            : "",
          Altitude: this.deliveryAddressModel.Altitude
            ? this.deliveryAddressModel.Altitude
            : "",
          DeliveryInstructions: this.deliveryAddressModel.DeliveryInstructions
        }
      })
        .then(() => {
          this.success = true;
          setTimeout(() => {
            this.success = false;
          }, 2000);
          this.hasError = false;
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.hasError = error;
        });
    },
    initModel() {
      this.detailModel.FirstName = this.dbuser.FirstName;
      this.detailModel.LastName = this.dbuser.LastName;
      this.detailModel.Email = this.user.email;
      //
      if (this.dbuser.DeliveryAddress) {
        this.deliveryAddressModel.StreetAddress = this.dbuser.DeliveryAddress.Address;
        this.deliveryAddressModel.PostalCode = this.dbuser.DeliveryAddress.PostCode;
        this.deliveryAddressModel.CityTown = this.dbuser.DeliveryAddress.City;
        this.deliveryAddressModel.Phone =
          this.dbuser.DeliveryAddress.Phone || "";
        this.deliveryAddressModel.State =
          this.dbuser.DeliveryAddress.State || "";
        this.deliveryAddressModel.Latitude =
          this.dbuser.DeliveryAddress.Latitude || "";
        this.deliveryAddressModel.Altitude =
          this.dbuser.DeliveryAddress.Altitude || "";
        this.deliveryAddressModel.DeliveryInstructions =
          this.dbuser.DeliveryAddress.DeliveryInstructions || "";
      }
    }
  }
};
